import { Component, Output, EventEmitter, HostBinding, Input, HostListener, ElementRef, Renderer2, AfterViewInit, OnInit, signal, inject, input, viewChild } from "@angular/core";
import { ITag } from "../../../../core-ui/models";
import { TinyColor } from "@ctrl/tinycolor";

@Component({
  selector: "av-tag",
  templateUrl: "./tag.component.html",
  styleUrls: ["./tag.component.scss"],
  standalone: false,
})
export class TagComponent implements OnInit, AfterViewInit {
  private renderer = inject(Renderer2);
  private host = inject<ElementRef<HTMLDivElement>>(ElementRef);

  readonly tag = input<ITag>(undefined);
  @Input()
  set active(value: boolean) {
    this.isActive = value;
    const tag = this.tag();
    if (!tag?.color) {
      return;
    }
    this.renderer.setStyle(
      this.host.nativeElement,
      "background-color",
      this.isActive ? tag?.color : null
    );
  }
  get active(): boolean {
    return this.isActive;
  }

  readonly actionIcon = input<string>(undefined);

  readonly plus = input<boolean>(undefined);

  @Output() remove: EventEmitter<ITag> = new EventEmitter();
  @Output() add: EventEmitter<ITag> = new EventEmitter();
  @Output() action: EventEmitter<ITag> = new EventEmitter();

  readonly colorElemRef = viewChild<ElementRef<HTMLDivElement>>("color");

  private isActive: boolean;
  isLight = signal(false);
  isTicked = signal(false);

  @HostBinding("class") get class() {
    return {
      "tag-active": this.active,
      "tag-clickable": this.add.observed || this.action.observed,
      "tag-light": this.isLight(),
      "tag-colorless": !this.tag()?.color,
      "tag-ticked": this.isTicked(),
    };
  }

  @HostListener("click")
  click() {
    const tag = this.tag();
    if (this.add.observed || this.plus()) {
      this.isTicked.set(true);
      setTimeout(() => {
        this.isTicked.set(false);
      }, 1000);
      this.add.emit(tag);
    }
    if (this.action.observed) {
      this.action.emit(tag);
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const tag = this.tag();
    if (tag?.color) {
      this.renderer.setStyle(
        this.colorElemRef().nativeElement,
        "background-color",
        tag?.color
      );
      const color = new TinyColor(tag?.color);
      this.isLight.set(color.isLight());
    }
  }

  tryRemove(event: Event) {
    event.stopPropagation();
    this.remove.emit(this.tag());
  }
}
